// extracted by mini-css-extract-plugin
export var container = "_po-0";
export var dotAnimation = "_po-2";
export var dotsLoading = "_po-1";